/**
 * Abfrageparameter der ArnoTop-Verwaltung (#1245).
 *
 * Die Filter entscheiden, was das Backend zählt und liefert. Ein leerer Filter
 * darf nicht als leerer Wert mitfahren — `status=` würde dort als „Status ist
 * leer" ankommen statt als „egal" —, und Mehrfachauswahlen fahren als eine
 * kommagetrennte Liste. Das ist genau die Art Regel, die man einmal aufschreibt
 * und prüft, statt sie an vier Stellen zu wiederholen.
 */

export type QueryValue = string | number | boolean | undefined | null;

/**
 * Baut die Abfragezeichenkette und lässt leere Werte weg.
 *
 * `false` und `0` bleiben erhalten: beide sind Angaben, keine Leerstellen.
 */
export const toQueryString = (parameters: Record<string, QueryValue>): string =>
  Object.entries(parameters)
    .filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join('&');

/** Mehrfachauswahl als ein Parameter; leere Auswahl heißt „kein Filter". */
export const listParameter = (values?: string[]): string | undefined =>
  values && values.length > 0 ? values.join(',') : undefined;
